export class SafetyPointModel {
    public SafetyPointId: number = 0;
    public SicherungssystemID: number = 0;
    public Bezeichnung: string = "";
    public ElectronicId: string | null = null;
    public AssetLink: string | null = null;
    
    public Longitude: number | null = null;
    public Latitude: number | null = null;
    public FormId: number | null = null;
}

export interface SafetyPointModelView extends SafetyPointModel {
    ObjektID: number
    RoofareaId: number,
    RoofareaBezeichnung?: string
    ObjektBezeichnung?: string
    SicherungssystemBezeichnung?: string,
    Strasse?: string
    Ort?: string
    PLZ?: string
    LandID?: number
    DebitorID?: number
    LandName?: string
    Debitornummer?: string
    Debitorname?: string
    FormName?: string
    StandortID?	:number
    StandortBezeichnung?	:string
    Erledigt? : boolean
    Image : string
}
